import type { OpenerDescalceRow } from '../../api/useOpenerDescalce';

type Venue = NonNullable<OpenerDescalceRow['venue']>;

/**
 * Whether a row's `descalce` can be read as a REAL, actionable residual when a
 * leg has already resolved. One predicate for the three places that would
 * otherwise disagree — the sort rank, the cell colour and the tooltip copy.
 *
 * The distinction is the backend's contract, not a heuristic. A backend that
 * carries `resolvingVenue` folds every resolved leg — a settled Kalshi one
 * from its settlement net, a redeemable Polymarket one from its held size —
 * back in as an OFFSET, capped so it can only cancel an imbalance and never
 * create one. Whatever descalce survives that is exposure on a leg that is
 * still live.
 *
 * A snapshot WITHOUT the field predates that arithmetic: there, a resolved
 * Polymarket leg was dropped from the counts outright and the live counter-leg
 * was left standing alone, so the number is a fabricated naked leg. Treating
 * it as real would send the operator hedging a position that is only waiting
 * to be redeemed — so the absent field falls back to the old "artefact"
 * handling, and this screen stays correct in either deploy order.
 */
export function residualIsReal(venue: Venue): boolean {
  if (!venue.resolving) return true;
  return venue.resolvingVenue != null;
}
